













import { Component, Mixins, Prop } from "vue-property-decorator";
import { ObjectSelectableContentMixin } from "./mixins";
import { default as WizardContentRadioSelectorOption } from "./WizardContentRadioSelectorOption.vue";

@Component({
  components: {
    WizardContentRadioSelectorOption,
  }
})
export default class WizardContentRadioSelector extends Mixins(ObjectSelectableContentMixin) {
  @Prop()
  scale: number;
}
